import { css, StyleSheet } from 'aphrodite';
import * as React from 'react';
export const FormIcon = ({ iconSrc, classObject }) => {
    return React.createElement("img", { src: iconSrc, className: css(styles.iconImage, classObject) });
};
const styles = StyleSheet.create({
    iconImage: {
        marginRight: 12,
    },
});
